export default "__VITE_PUBLIC_ASSET__9e67fd19__"